export default class RuntimeUtils {
    static get instance() {
        if (!RuntimeUtils._instance) {
            RuntimeUtils._instance = new RuntimeUtils();
        }
        return RuntimeUtils._instance;
    }

    static _instance;

    constructor() {
        this.protocol = window.location.protocol;
        this.hostname = window.location.hostname;
        this.devServiceHostName = 'cloud.dev.pkpm.cn';
        this.obvDevServiceHostname = 'cloud.dev.pkpm.cn';
        this.obvProductionServiceHostName = 'api.cloud.pkpm.cn';
        // 单独的后台地址
        this.passportProductionServiceHostName = 'cloud.pkpm.cn';
        this.viewerPath = '/bimviewer/viewer/v4';
        this.servicePath = '/bimserver/viewing/v3';
        this.viewer5Path = '/bimviewer/viewer/v5';
    }

    getSendEmailHostname() {
        let { hostname } = this;

        // 判断当前域名值
        if (this.isProductionEnvironment) {
            hostname = this.hostname;
        } else if (this.isDevEnvironment) {
            hostname = this.hostname;
        } else if (this.isLocalEnvrionment) {
            hostname = this.hostname;
        }
        return hostname;
    }

    get isLocalEnvrionment() {
        return (
            this.hostname === 'localhost' ||
            this.hostname === '127.0.0.1' ||
            this.hostname === 'bimviewer-local.aecworks.cn'
        );
        // return false
    }

    get isDevEnvironment() {
        return this.hostname.toLocaleLowerCase() === this.devServiceHostName;
        // return false
    }

    get isProductionEnvironment() {
        return !this.isLocalEnvrionment && !this.isDevEnvironment;
    }

    get obvEnv() {
        if (this.isProductionEnvironment) {
            return this.obvProductionServiceHostName;
        }
        return this.obvDevServiceHostname;
    }

    get obvCssPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${this.viewerPath}/obv.css`;
    }

    get obvPropertiesPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${
            this.viewerPath
        }/locale/locale.properties`;
    }

    get obvJsPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${this.viewerPath}/obv.js`;
    }

    get obv5CssPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${this.viewer5Path}/obv.css`;
    }

    get obv5PropertiesPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${
            this.viewer5Path
        }/locale/locale.properties`;
    }

    get obv5JsPath() {
        return `${this.getObvServiceProtocol()}//${this.getObvServiceHostname()}${this.viewer5Path}/obv.js`;
    }

    get webPort() {
        if (this.isLocalEnvrionment) {
            return '8100';
        }
        return '80';
    }

    get snippetPort() {
        if (this.isLocalEnvrionment) {
            return '8080';
        }
        return window.location.port;
    }

    getIframeUrl(type) {
        if (type === 'externalObject') {
            return `${window.location.origin}/playground/playground-object.html`;
        }
        if (type === '2d') {
            return `${window.location.origin}/playground/playground-2d.html`;
        }
        if (type === '2dMarker') {
            return `${window.location.origin}/playground/playground-2dMarker.html`;
        }
        if (type === 'paste2dAddin') {
            return `${window.location.origin}/playground/playground-paste2d.html`;
        }
        return `${window.location.origin}/playground/playground-3d.html`;
    }

    getObvServiceProtocol() {
        let { protocol } = this;

        // 生产、开发和本地环境默认用 https
        if (this.isProductionEnvironment) {
            protocol = this.protocol;
        } else if (this.isDevEnvironment) {
            protocol = this.protocol;
        } else if (this.isLocalEnvrionment) {
            protocol = 'https:';
        }
        return protocol;
    }

    getObvServiceHostname() {
        let serviceHostname;
        if (this.isProductionEnvironment) {
            serviceHostname = this.obvProductionServiceHostName;
        } else if (this.isDevEnvironment) {
            // serviceHostname = this.obvProductionServiceHostName;
            serviceHostname = this.obvDevServiceHostname;
        } else if (this.isLocalEnvrionment) {
            // serviceHostname = this.obvProductionServiceHostName;
            serviceHostname = this.obvDevServiceHostname;
        }
        return serviceHostname;
    }

    // 获取后台服务地址
    getCloudServiceHostname() {
        let serviceHostname;
        if (this.isProductionEnvironment) {
            serviceHostname = this.obvProductionServiceHostName;
        } else if (this.isDevEnvironment) {
            serviceHostname = this.obvDevServiceHostname;
        } else if (this.isLocalEnvrionment) {
            serviceHostname = this.obvDevServiceHostname;
        }
        return serviceHostname;
    }

    // 获取后台服务地址
    getConsoleServiceHostname() {
        let serviceHostname;
        if (this.isProductionEnvironment) {
            serviceHostname = this.passportProductionServiceHostName;
        } else if (this.isDevEnvironment) {
            serviceHostname = this.obvDevServiceHostname;
        } else if (this.isLocalEnvrionment) {
            serviceHostname = this.obvDevServiceHostname;
        }
        return serviceHostname;
    }

    // 获取passport地址
    getPassportServiceHostname() {
        let serviceHostname;
        if (this.isProductionEnvironment) {
            serviceHostname = `${this.getObvServiceProtocol()}//${
                this.passportProductionServiceHostName
            }/bimserver/console/v3/signIn`;
        } else if (this.isDevEnvironment) {
            serviceHostname = `${this.getObvServiceProtocol()}//${
                this.obvDevServiceHostname
            }/bimserver/console/v3/signIn`;
        } else if (this.isLocalEnvrionment) {
            serviceHostname = `${this.getObvServiceProtocol()}//${
                this.obvDevServiceHostname
            }/bimserver/console/v3/signIn`;
            // serviceHostname = `http://localhost:8080/bimserver/console/v3/signIn`;
        }
        return serviceHostname;
    }

    // 获取clientId
    getClientId() {
        let clientId;
        if (this.isProductionEnvironment) {
            clientId = '1HVWyU2RBtOc2l25kl2GUN0D';
        } else if (this.isDevEnvironment) {
            clientId = '4QPxSf1n8FfG2wKXr424BgN';
        } else if (this.isLocalEnvrionment) {
            clientId = '4QPxSf1n8FfG2wKXr424BgN';
        }
        return clientId;
    }

    // 获取state回调地址
    getState() {
        return `${window.location.origin}/login`;
    }
}



// WEBPACK FOOTER //
// ./src/common/js/runtimeUtils.js